import { dateToIsoDateString } from "@/utils/utils";
import { Badge, Button } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useGetDashboardPersonalDates } from "../../../../../common/api/queries";
import { PresetColors } from "../../../../../common/constants";

type Props = {
  showPersonalDatesExtendedModal: () => void;
};

export const DashboardPersonalDatesExtendedButton = ({ showPersonalDatesExtendedModal }: Props) => {
  const { t } = useTranslation();

  const { data } = useGetDashboardPersonalDates({
    minDate: dateToIsoDateString(dayjs().startOf("day")),
    maxDate: dateToIsoDateString(dayjs().endOf("day")),
  });

  const selectedDayPersons = data?.personalDates[dateToIsoDateString(dayjs())] || [];

  return (
    <Badge count={selectedDayPersons.length} color={PresetColors.BLUE}>
      <Button type="primary" size="large" onClick={showPersonalDatesExtendedModal}>
        {t("dashboard.personalDatesExtended.actions.show")}
      </Button>
    </Badge>
  );
};
